import {createClient} from '@supabase/supabase-js';
import {tenantHost} from '@common/supabase/tenant';

const url = import.meta.env.VITE_SUPABASE_URL as string;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

if (!url || !anonKey) {
  console.error(
    'VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY must be set in .env.local',
  );
}

// supabase-js default storage key
const appStorageKey = `sb-${new URL(url || 'http://localhost').hostname.split('.')[0]}-auth-token`;
export const widgetStorageKey = 'sb-livechat-widget-auth-token';

export function isLivechatWidgetPage() {
  return window.location.pathname.startsWith('/lc/widget');
}

/**
 * The chat widget (/lc/widget) runs as the signed in user when the main app
 * has a session. Otherwise visitors get an anonymous session that is stored
 * separately, so they never show up as logged in on the help center.
 */
function storageKey() {
  if (!isLivechatWidgetPage()) return appStorageKey;
  try {
    if (window.localStorage.getItem(appStorageKey)) return appStorageKey;
  } catch {
    // storage blocked (third party iframe), session lives in memory
  }
  return widgetStorageKey;
}

export const supabase = createClient(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: !isLivechatWidgetPage(),
    storageKey: storageKey(),
  },
  // selects the helpdesk (tenant) in the database, see current_tenant_id()
  global: {headers: {'x-tenant-host': tenantHost}},
});

export const supabaseUrl = url;
export const supabaseAnonKey = anonKey;
